export default theme => ({
    errorStyle: {
        color: theme.palette.red.primary,
        marginTop: 6
    },
});
